import React from 'react';
import { reduxForm } from 'redux-form';
import { Field } from 'redux-form';
import { SaveButton } from '.';
import { Textarea } from '../form';

let NoteForm = props => {
  const { handleSubmit, saving, fieldName, rows, cols, wrapperClasses, textareaWrapperClasses, buttonClasses } = props;
  return (
    <form onSubmit={handleSubmit} className={`${wrapperClasses}`}>
      <Field name={fieldName} label="Add Note" placeholder="Write a note..." component={Textarea} cols={cols ?? 40} rows={rows ?? 5} className="form-control" wrapperClasses={`form-group ${textareaWrapperClasses}`} />
      <SaveButton buttonClasses={`float-right px-3 py-2 ${buttonClasses}`} label="Post" saving={saving} />
    </form>
  )
}

NoteForm = reduxForm({
  form: 'noteForm',
  enableReinitialize: true
})(NoteForm)

export default NoteForm;